import React from 'react';
import PropTypes from 'prop-types';
import { AppText } from 'domain/appText';

import { PageTemplate, Footer } from 'components';
import { ReservationWrapper, Header } from 'containers';
import ReservationLoader from '../../../loaders/ReservationLoader';

const ReservationPage = ({ match: { params: { reservation, lang } } }) => (
  <PageTemplate header={<Header reservation={reservation} />} footer={<Footer />}>
    <ReservationLoader text={AppText} id={reservation} lang={lang} component={<ReservationWrapper />} />
  </PageTemplate>
);

ReservationPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      reservation: PropTypes.string,
      lang: PropTypes.string,
    }),
  }).isRequired,
};

export default ReservationPage;



// WEBPACK FOOTER //
// ./src/components/pages/ReservationPage/index.js